import { graphql } from 'react-apollo';

import { QUERY } from '../../../../../../../graphql/queries/accountHoldersQuery';
import { MUTATION } from '../../../../../../../graphql/mutations/updateDefaultFinancialAccount';

export default graphql(MUTATION, {
  props: ({ mutate }) => ({
    updateDefaultFinancialAccount: ({ accountHolderId, financialAccountId }) =>
      mutate({
        variables: {
          accountHolderId: parseInt(accountHolderId, 10),
          financialAccountId
        }
      })
  }),
  options: {
    refetchQueries: [{ query: QUERY }],
    fetchPolicy: 'no-cache'
  }
});
